import React from 'react';
import { ShoppingCart, ChevronLeft, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext
} from "@/components/ui/carousel";
import { useEffect, useState, useRef } from 'react';

const products = [
  {
    id: "taper-candles",
    name: "Столовые свечи",
    description: "В коллекции палитра из 37 классических и лимитированных цветов и оттенков.",
    price: "790 ₽",
    images: [
      "/images/taper-candles.png"
    ],
    marketplaces: [
      {
        name: "OZON",
        url: "https://www.ozon.ru/product/nabor-svechey-pchelinyy-vosk-26-sm-h-2-sm-6-sht-1926749668/"
      },
      {
        name: "Яндекс Маркет",
        url: "https://market.yandex.ru/pr/51335668667"
      }
    ]
  },
  {
    id: "placeholder-product",
    name: "Интерьерные свечи",
    description: "Следите за обновлениями! Скоро появятся новые изысканные свечи.",
    price: "Уточняйте",
    images: [
      "/placeholder.svg"
    ],
    marketplaces: []
  }
];

const Products = () => {
  const carouselRefs = useRef<Record<string, any>>({});
  const [currentSlide, setCurrentSlide] = useState<Record<string, number>>({});

  useEffect(() => {
    // Настройка автосмены слайдов для каждого продукта
    const intervals: Record<string, NodeJS.Timeout> = {};
    
    products.forEach(product => {
      if (product.images.length > 1) {
        intervals[product.id] = setInterval(() => {
          if (carouselRefs.current[product.id] && carouselRefs.current[product.id].scrollNext) {
            carouselRefs.current[product.id].scrollNext();
          }
        }, 4000); // Меняем слайд каждые 4 секунды для лучшего восприятия
      }
    });

    return () => {
      // Очистка интервалов при размонтировании компонента
      Object.values(intervals).forEach(interval => clearInterval(interval));
    };
  }, []);

  const setCarouselRef = (id: string, api: any) => {
    carouselRefs.current[id] = api;
    
    // Установка начального слайда и добавление обработчика для отслеживания текущего слайда
    if (api) {
      api.on("select", () => {
        setCurrentSlide(prev => ({
          ...prev,
          [id]: api.selectedScrollSnap()
        }));
      });
    }
  };

  return (
    <section className="py-24 bg-white" id="products">
      <div className="container px-4">
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {products.map((product, index) => (
            <div key={index} className="overflow-hidden bg-white shadow-lg transition-all flex flex-col">
              <div className="relative flex-grow">
                <Link to={`/products/${product.id}`} className="block h-full">
                  <div className="relative h-full aspect-square">
                    <img
                      src={product.images[0]}
                      alt={`Изображение товара: ${product.name}`}
                      width="400"
                      height="400"
                      loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-300"
                    />
                  </div>
                </Link>
              </div>
              <div className="p-6 flex flex-col justify-between flex-grow-0 text-center">
                <div>
                  <Link to={`/products/${product.id}`}>
                    <h3 className="text-xl font-bold mb-2 hover:text-honey-600 transition-colors">{product.name}</h3>
                  </Link>
                  <p className="text-gray-600 mb-4 line-clamp-3">{product.description}</p>
                </div>
                <Link
                  to={`/products/${product.id}`}
                  className="mt-4 inline-block border border-black hover:bg-black hover:text-white text-black px-6 py-2 rounded-full text-sm font-medium transition-all w-full text-center"
                >
                  Подробнее
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
